import { Typography } from '@mui/joy';

interface PageTitleProps {
	title: string;
}

export const PageTitle = ({ title }: PageTitleProps) => {
	return (
		<Typography level='h1' sx={{ marginTop: '10px' }}>
			{title}
		</Typography>
	);
};
